import { styled } from '@components-shared/src/stitches';
import { StyledScroll } from '@components/main-components/containers/RadixScroll';

export const ScrollArea = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  overflow: 'auto',
  gap: 24,
  marginTop: 24,

  ...StyledScroll,
});

export const TextBlurb = styled('div', {
  base: 'M',
  color: '$neutral400',
  '@tablet': {
    fontSize: 16,
    lineHeight: '20px',
  },

  variants: {
    legacy: {
      true: {
        marginTop: -8,
        '@tablet': {
          marginTop: -16,
        },
      },
    },
  },
});
